var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { isValidInt, replaceAll } from "framework/helpers";
import { updateByCollectionResponse } from "framework/state/collection";
import { NoEntityError } from "framework/validation/validatableentity";
import { getPartnershipRegistrationStateValues, getPartnershipStatusText } from "common/partnerships/entity";
import { loadListOfPartnerships } from "common/partnerships/endpoint";
import { DisciplineType, SeriesType } from "public_app/events/entity";
import { getDisciplineTypeAbbreviation, getSeriesTypeAbbreviation } from "public_app/view/entity";
var filterSeriesSelectOptions = [{ key: "undefined", value: "vše" }].concat([SeriesType.DanceSport, SeriesType.DanceForAll, SeriesType.Professional, SeriesType.Caribbean].map(function (s) {
    return {
        key: s.valueOf().toString(),
        value: getSeriesTypeAbbreviation(s)
    };
}));
var filterDisciplineSelectOptions = [{ key: "undefined", value: "vše" }].concat([DisciplineType.Standard, DisciplineType.Latin, DisciplineType.Caribbean].map(function (s) {
    return {
        key: s.valueOf().toString(),
        value: getDisciplineTypeAbbreviation(s)
    };
}));
var filterStateSelectOptions = [{ key: "undefined", value: "vše" }].concat(getPartnershipRegistrationStateValues().map(function (s) {
    return {
        key: s.valueOf().toString(),
        value: getPartnershipStatusText(s)
    };
}));
var initialize = function (clubId) { return function (store) {
    store.setState(function (draft) {
        draft.data = [];
        draft.collection = [];
        draft.columnInfo = [
            { heading: "jména osob", field: "people", sortable: false, filterable: true },
            { heading: "seriál", field: "series", sortable: false, filterable: true, equalityFilter: true, filterSelectOptions: filterSeriesSelectOptions },
            { heading: "disciplína", field: "discipline", sortable: false, filterable: true, equalityFilter: true, filterSelectOptions: filterDisciplineSelectOptions },
            { heading: "věk", field: "age", sortable: false, filterable: false },
            { heading: "stav", field: "state", sortable: false, filterable: true, equalityFilter: true, filterSelectOptions: filterStateSelectOptions },
        ];
        draft.columnStates = [
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
            { filter: "", sort: null },
        ];
        draft.pageSize = 25;
        draft._initialized = true;
        draft.clubId = clubId !== null && clubId !== void 0 ? clubId : null;
        draft.competitorType = null;
    });
}; };
var getQueryParameters = function (state) {
    var params = {};
    params["page"] = state.pageNumber.toString();
    params["pageSize"] = state.pageSize.toString();
    var sortSpecification = [];
    state.columnStates.forEach(function (cs, cs_idx) {
        if (cs.sort !== null) {
            sortSpecification.push("".concat(replaceAll(state.columnInfo[cs_idx].field, ".", "/"), " ").concat(cs.sort));
        }
    });
    var orderby = sortSpecification.length == 0 ? null : sortSpecification.join(",");
    if (orderby !== null) {
        params["order"] = orderby;
    }
    var peopleColumnFilterValue = state.columnStates[0].filter;
    var filteredFieldIdxs = state.columnInfo.map(function (ci, ci_idx) { return ci_idx; })
        .filter(function (idx) { return state.columnStates[idx].filter !== "" && state.columnStates[idx].filter !== "undefined" && state.columnInfo[idx].field !== "people"; });
    var filter = filteredFieldIdxs.length == 0 ?
        null :
        filteredFieldIdxs.map(function (idx) {
            var filterValue = state.columnInfo[idx].multiOption ? "('".concat(state.columnStates[idx].filter.toString(), "')") : "'".concat(state.columnStates[idx].filter.toString(), "'");
            var filterOperator = state.columnInfo[idx].multiOption ? 'IN' : (state.columnInfo[idx].equalityFilter === true ? '=' : 'LIKE');
            return "".concat(replaceAll(state.columnInfo[idx].field, ".", "/"), " ").concat(filterOperator, " ").concat(filterValue);
        }).join(' and ');
    if (state.clubId !== null) {
        var clubFilter = "clubId=".concat(state.clubId);
        if (filter !== null && filter !== '') {
            filter = "".concat(filter, " and ").concat(clubFilter);
        }
        else {
            filter = "".concat(clubFilter);
        }
    }
    if (state.competitorType !== null) {
        var competitorTypeFilter = "competitorType=".concat(state.competitorType);
        if (filter !== null && filter !== '') {
            filter = "".concat(filter, " and ").concat(competitorTypeFilter);
        }
        else {
            filter = "".concat(competitorTypeFilter);
        }
    }
    if (peopleColumnFilterValue !== "") {
        var peopleColumnFilter = '';
        if (isValidInt(peopleColumnFilterValue)) {
            peopleColumnFilter = "idt='".concat(peopleColumnFilterValue, "'");
        }
        else {
            peopleColumnFilter = "personName LIKE '".concat(peopleColumnFilterValue, "'");
        }
        if (filter !== null && filter !== '') {
            filter = "".concat(filter, " and ").concat(peopleColumnFilter);
        }
        else {
            filter = "".concat(peopleColumnFilter);
        }
    }
    if (filter !== null && filter !== '') {
        params["filter"] = filter;
    }
    return params;
};
var loadData = function () { return function (store) {
    var params = getQueryParameters(store.getState());
    var loader = function () { return loadListOfPartnerships(params); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
            if (response.succeeded) {
                draft.data = draft.collection;
                draft.paging.page = response.data.paging.page;
                draft.paging.pageSize = response.data.paging.pageSize;
                draft.paging.totalCount = response.data.paging.totalCount;
                draft.pageCount = Math.ceil(draft.paging.totalCount / draft.pageSize);
            }
            else {
                draft.data = [];
                draft.pageNumber = 1;
                draft.pageCount = 0;
            }
        });
    };
    loadLast(store, loader, stateProducer);
}; };
var getColumnIndexByField = function (field, store) {
    var s = store.getState();
    var res = s.columnInfo.find(function (x) { return x.field === field; });
    return s.columnInfo.indexOf(res);
};
var setFilter = function (field, value) { return function (store) {
    var idx = getColumnIndexByField(field, store);
    if (idx >= 0) {
        store.setState(function (draft) {
            draft.columnStates[idx].filter = value;
            draft.pageNumber = 1;
        });
        store.dispatch(loadData());
    }
}; };
var setCompetitorType = function (value) { return function (store) {
    store.setState(function (draft) {
        draft.competitorType = value;
    });
    store.dispatch(loadData());
}; };
var setOrder = function (field, value) {
    if (value === void 0) { value = null; }
    return function (store) {
        var idx = getColumnIndexByField(field, store);
        if (idx >= 0) {
            var current_sort = store.getState().columnStates[idx].sort;
            var new_sort_1 = current_sort === null ? "asc" : current_sort === "asc" ? "desc" : null;
            store.setState(function (draft) {
                draft.columnStates.forEach(function (cs) { return cs.sort = null; });
                draft.columnStates[idx].sort = new_sort_1;
            });
            store.dispatch(loadData());
        }
    };
};
var setPageNumber = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.pageNumber = val;
    });
    store.dispatch(loadData());
}; };
var setPageSize = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.pageSize = val;
        draft.pageNumber = 1;
    });
    store.dispatch(loadData());
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), data: [], columnInfo: [], columnStates: [], pageNumber: 1, pageCount: 0, pageSize: 25, _initialized: false, paging: {
        page: 1,
        pageSize: 25,
        totalCount: 0,
    }, clubId: null, competitorType: null });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFilter: setFilter,
        setOrder: setOrder,
        initialize: initialize,
        loadData: loadData,
        setPageNumber: setPageNumber,
        setPageSize: setPageSize,
        setCompetitorType: setCompetitorType,
    },
    name: "MembersListAdmin"
});
var useState = createHook(store);
export { StateDefaults as PartnershipListAdminDefaults, useState as usePartnershipListAdmin, };
